import ActiveProcessInstanceTableAction from './ActiveProcessInstanceTableAction';

export default ActiveProcessInstanceTableAction;
